var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rich-text-input",class:{
        'rich-text-input--block': _vm.block,
    }},[_c('div',{ref:"quillContainer"})])}
var staticRenderFns = []

export { render, staticRenderFns }